import { BackButton } from '@components/buttons';
import { Card, CircularProgress } from '@hyperflake/react-ui-library';
import { Breadcrumb } from '@library/breadcrumb';
import useClientData from 'modules/clients/hooks/useClientData';
import useClientListData from 'modules/clients/hooks/useClientListData';
import ClientList from 'modules/notification/components/ClientList/ClientList';
import ClientNotificationForm from 'modules/notification/components/ClientNotificationForm/ClientNotificationForm';
import UserList from 'modules/notification/components/UserList/UserList';
import UserNotificationForm from 'modules/notification/components/UserNotifcationForm/UserNotifcationForm';
import useUserListData from 'modules/users/hooks/useUserListData';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

const UserNotificationDetailPage = () => {
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const { clientId } = useParams();
    const { client, isLoading: isLoadingClient } = useClientData(clientId);
    const [searchValue, setSearchValue] = useState('');

    const { data: users, isLoading } = useUserListData(clientId);

    const resetState = () => {
        setSelectedIds([]);
        setSelectAllChecked(false);
        setSearchValue('');
    };
    //     const navArray = [
    //         { label: 'Clients', onClick: () => navigate('/client') },
    // ]

    if (isLoadingClient)
        return (
            <div className="fixed inset-0 flex items-center justify-center">
                <CircularProgress />
            </div>
        );

    return (
        <>
            <div className="flex gap-2 mt-2">
                <BackButton className="" />
            </div>
            <div className="mt-2 font-semibold text-base">{client.name}</div>
            {/* <Breadcrumb separator="/" items={navArray} /> */}
            <Card className="mt-2">
                <Card.Body>
                    <div className="grid grid-cols-12 gap-8">
                        <div className="col-span-5 border-r pr-8">
                            <UserNotificationForm users={users} selectedIds={selectedIds} resetState={resetState} />
                        </div>
                        <div className="col-span-7">
                            <UserList
                                users={users}
                                isLoading={isLoading}
                                selectedIds={selectedIds}
                                setSelectedIds={setSelectedIds}
                                selectAllChecked={selectAllChecked}
                                setSelectAllChecked={setSelectAllChecked}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
};

export default UserNotificationDetailPage;
